import gql from 'graphql-tag';

import {
  PlusOneGuest,
  SingleEventPlusOneGuestInput,
  SINGLE_EVENT_PLUS_ONE_GUEST_FRAGMENT
} from 'types/plus-one.types';

export interface AdminUpdatePlusOneGuestInput {
  eventId: number;
  gid: string;
  plusOneGuest: SingleEventPlusOneGuestInput;
  sendNotifications?: boolean;
}

export interface AdminUpdatePlusOneGuestVariables {
  input: AdminUpdatePlusOneGuestInput;
}

export interface AdminUpdatePlusOneGuestResponse {
  adminUpdatePlusOneGuest: {
    ok: boolean;
    plusOneGuest: PlusOneGuest;
  };
}

export const ADMIN_UPDATE_PLUS_ONE_GUEST_MUTATION = gql`
  mutation adminUpdatePlusOneGuest($input: AdminUpdatePlusOneGuestInput!) {
    adminUpdatePlusOneGuest(input: $input) {
      ok
      plusOneGuest {
        ...SingleEventPlusOneFields
      }
    }
  }
  ${SINGLE_EVENT_PLUS_ONE_GUEST_FRAGMENT}
`;
